/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_EmailInputs */

const en_tables_pause_reasons_email = /** @type {(inputs: Tables_Pause_Reasons_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons Email`)
};

const de_tables_pause_reasons_email = /** @type {(inputs: Tables_Pause_Reasons_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

/**
* | output |
* | --- |
* | "Reasons Email" |
*
* @param {Tables_Pause_Reasons_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_email = /** @type {((inputs?: Tables_Pause_Reasons_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_email(inputs)
	return de_tables_pause_reasons_email(inputs)
});